import { useTranslation } from "react-i18next";

export function useDetectLanguage() {
    const { i18n } = useTranslation();
    return i18n.language; // always returns current i18n language
}
